import { useContext, useEffect, useState } from "react";
import { PoliticalPartyDBContext } from "./PoliticalPartyDBContext";
import { contestationPeriodsService } from "../../services/ContestationPeriodsService";
import ScreenLoader from "../../componets/ScreenLoader";
import { Dropdown } from "primereact/dropdown";
import PoliticalPartyService from "../../services/PoliticalPartyService";
import { formatDate } from "../../config/Config";
import { Badge } from "primereact/badge";

export default function () {
    var { selectedParty, setSelectedParty, contestationPeriodID, setContestationPeriodID, partyExecutiveTermID, setPartyExecutiveTermID } = useContext(PoliticalPartyDBContext);
    var [contestationPeriod, setContestationPeriod] = useState([]);
    var [loading, setLoading] = useState(true);
    var politicalPartyService = new PoliticalPartyService()


    function getStatus(status) {
        switch (status) {
            case "Active":
                return "success"
            case "Upcoming":
                return "info"
            default:
                return "danger"
        }
    }

    const itemOptionTemplate = (option) => {
        return (
            <div className="flex align-items-center">
                <span className="mr-2"> <Badge value={option.status} severity={getStatus(option?.status)} /> </span>
                <span >
                    {formatDate(option.startDate)} - {formatDate(option.endDate)}
                </span>
            </div>
        );
    };
    useEffect(() => {
        setLoading(true)
        politicalPartyService.getExecutiveTerms(selectedParty?.politicalPartyID).then(res => {
            setContestationPeriod(res.map(e => {
                e.dom_key = itemOptionTemplate(e)
                return e;
            }))
            var neverMet = true
            res.forEach(res => {
                if (res.status === "Active") {
                    // if (["", null, undefined].includes(partyExecutiveTermID)) {
                    neverMet = false
                    setPartyExecutiveTermID(res.partyExecutiveTermID)
                    return;
                    // }
                }
            })
            if (neverMet) {
                setPartyExecutiveTermID(null)
            }
            setLoading(false)
        })
    }, [])


    return (<>
        <ScreenLoader visible={loading} />
        <div>
            <b>Executive Term</b>
            <br />
            <Dropdown

                value={partyExecutiveTermID} onChange={e => setPartyExecutiveTermID(e.value)} className="w-full" options={contestationPeriod} optionLabel="dom_key" optionValue="partyExecutiveTermID" />
        </div>
    </>)
}